import { useTranslation } from '@frontend/i18n';
import { shell } from '@frontend/shell-utils';
import { theme } from '@frontend/theme';
import { Text, PrimaryButton } from '@frontend/design-system';

export const VersionSection = ({ nextVersion }: { nextVersion: string | undefined }) => {
  const { t } = useTranslation('base');
  const onUpdateClick = () => {
    if (nextVersion) shell?.emit?.('restart', undefined);
  };
  if (!nextVersion) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(1) }}>
      <Text color='subdued' size='small' css={{ alignSelf: 'end' }}>
        {t('Version {{currentVersion}}', { currentVersion: shell.version ?? 'Unknown' })}
      </Text>
      <div
        style={{
          borderRadius: theme.borderRadius.medium,
          boxShadow: theme.shadows.floating,
          display: 'grid',
          gridTemplateRows: `repeat(4, minmax(${theme.spacing(2)}, auto))`,
          padding: theme.spacing(1, 2),
        }}
      >
        <Text size='medium' weight='bold' as='span'>
          {t('A new version is available: {{version}}', { version: nextVersion })}
        </Text>
        <Text size='medium' color='subdued' as='span'>
          {t('Please restart the app to update')}
        </Text>
        <PrimaryButton css={{ gridArea: '4/1', width: 'max-content' }} onClick={onUpdateClick}>
          {t('Restart Now')}
        </PrimaryButton>
      </div>
    </div>
  );
};
